'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  DETECT_AUTH: 'detect-auth',
  EXISTING_USER: 'existing-user',
  JOIN_HUBSPOT: 'join-hubspot',
  JOIN_HUBSPOT_ACCOUNT: 'join-hubspot-account',
  JOIN_HUBSPOT_USER: 'join-hubspot-user',
  JOIN_HUBSPOT_EMPLOYEE: 'join-hubspot-employee',
  JOIN_HUBSPOT_ACADEMY: 'join-hubspot-academy',
  EXISTING_ACCOUNTS: 'existing-accounts',
  EXISTING_ACCOUNTS_MINIMAL: 'existing-accounts-minimal',
  DOMAIN: 'domain',
  CLIENT_DOMAIN: 'client-domain',
  CREATE: 'create',
  AUTHENTICATE: 'authenticate',
  GETTING_STARTED: 'getting-started',
  GETTING_STARTED_FALLBACK: 'getting-started-fallback',
  PARTNER_REDIRECT: 'partner-redirect',

  // popup login
  DETECT_AUTH_AFTER_POPUP: 'detect-auth-after-popup',
  LOGIN_REDIRECT: 'login-redirect',

  // login fallbacks
  FORCE_LOGIN: 'force-login',
  FORCE_PARTNER_LOGIN: 'force-partner-login',
  FORCE_FB_LOGIN: 'force-fb-login',
  EXISTING_ACCOUNT_LOGIN: 'existing-account-login',

  // oauth
  GOOGLE_OAUTH: 'google-oauth',
  GOOGLE_OAUTH_LANDING: 'google-oauth-landing',

  // marketplace
  WORDPRESS_CONNECT: 'wordpress-connect',
  WORDPRESS_INTRO: 'wordpress-intro',
  SIGNUP_OR_LOGIN: 'signup-login',
  LOGIN_OR_GET_INVITED: 'login-invited',

  // invited
  VALIDATE: 'validate',
  INVITED_ERROR: 'invited-error',
  WELCOME: 'welcome',
  PASSWORD: 'password',

  // partner
  PROVISION: 'provision',

  // checkout
  CREATE_CHECKOUT_USER: 'create-user',
  ACTIVATE_CHECKOUT_USER: 'activate-user',

  // behalf of a client
  JOIN_AS_CLIENT: 'join-as-client',
  JOIN_HUBSPOT_CLIENT: 'join-hubspot-client',
  SURVEY_PARTNER: 'survey-partner',
  EXISTING_JOIN_AS_CLIENT: 'existing-join-as-client',

  GENERAL_ERROR: 'general-error'
};
module.exports = exports['default'];